module.exports = require("core-js-pure/features/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/get-own-property-descriptors.js
// module id = 489
// module chunks = 13